import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  Collapse,
  Button,
  Progress,
  Space,
  Input
} from '@lockerpm/design';

import {
  LeftOutlined,
  RightOutlined
} from "@ant-design/icons";

import {
  green
} from '@ant-design/colors';

import CollapseHeader from "./CollapseHeader";

import rewardServices from "../../../../services/reward";
import global from "../../../../config/global";

const GooglePlayRating = (props) => {
  const { t } = useTranslation();
  const stepNumber = 2;

  const {
    className,
    missionSteps = [],
    mission = {},
    verify = () => {},
    resubmit = () => {}
  } = props;

  const [collapseKeys, setCollapseKeys] = useState([])
  const [callingAPI, setCallingAPI] = useState(false)
  const [stepIndex, setStepIndex] = useState(0)
  const [percent, setPercent] = useState(0)
  const [displayName, setDisplayName] = useState(null)

  const missionStep = useMemo(() => {
    const step = missionSteps.find(
      s => s.value === mission?.status
    )
    return step || missionSteps[0]
  }, [mission])

  useEffect(() => {
    fetchData()
  }, [mission])

  useEffect(() => {
    if (missionStep.key === 1) {
      setStepIndex(0)
    } else {
      setStepIndex(stepNumber - 1)
    }
  }, [missionStep])

  useEffect(() => {
    if (missionStep.key === 3) {
      setPercent(100)
    } else {
      setPercent(stepIndex / stepNumber * 100)
    }
  }, [stepIndex, missionStep])

  const fetchData = () => {
    setDisplayName(mission?.answer?.user_identifier || '')
  }

  const handleSend = async () => {
    const action = t('rewards.google_play_rating.title');
    const store = 'Google Play'
    setCallingAPI(true);
    await rewardServices.mission_completed(
      mission.mission.id,
      { user_identifier: displayName }
    ).then((res) => {
      if (res.claim) {
        verify({
          action,
          percent: 5,
        })
      } else {
        resubmit({
          action,
          store,
        })
      }
    }).catch(() => {
      resubmit({
        action,
        store,
      })
    })
    setCallingAPI(false);
  }

  return (
    <div className={`google-play-rating ${className}`}>
      <Collapse
        activeKey={collapseKeys}
        expandIconPosition={'end'}
        onChange={setCollapseKeys}
      >
        <Collapse.Panel
          key="1"
          header={<CollapseHeader
            title={t('rewards.google_play_rating.title')}
            percent={5}
            missionStep={missionStep}
            collapseKeys={collapseKeys}
            Right={(props) => {
              return <a
                className={props.className}
                href={global.urls.GOOGLE_PLAY_URL}
                target="_blank"
              >
                <Button
                  type="primary"
                >
                  {t('rewards.google_play_rating.header_btn') }
                </Button>
              </a>
            }}
          />}
        >
          <div>
            <div className="lg:w-full md:w-full mb-4">
              {t('rewards.google_play_rating.subtitle')}
            </div>
            <div className={`mission-steps ${className}`}>
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center">
                  <p className="text-l font-semibold mr-4">{t('common.steps')}:</p>
                  <Progress
                    steps={stepNumber}
                    percent={percent}
                    showInfo={false}
                    strokeColor={green[6]}
                  />
                </div>
                {
                  missionStep.key !== 3 && <Space size={[12, 12]}>
                    <Button
                      type="text"
                      disabled={stepIndex === 0}
                      icon={<LeftOutlined />}
                      onClick={() => setStepIndex(stepIndex - 1)}
                    />
                    <Button
                      type="text"
                      disabled={stepIndex === stepNumber - 1}
                      icon={<RightOutlined />}
                      onClick={() => setStepIndex(stepIndex + 1)}
                    />
                  </Space>
                }
              </div>
              {
                stepIndex === 0 && <p>{t('rewards.google_play_rating.step1')}</p>
              }
              {
                stepIndex === 1 && <div>
                  <p>{t('rewards.google_play_rating.step2')}</p>
                  <div className="mt-4 flex items-center">
                    <Input
                      className="mr-2 w-[360px]"
                      value={displayName}
                      placeholder={t('rewards.google_play_rating.input_placeholder')}
                      disabled={callingAPI}
                      onChange={(e) => setDisplayName(e.target.value)}
                    />
                    <Button
                      disabled={!displayName || missionStep.key == 3}
                      type={missionStep.key == 3 ? undefined : 'primary'}
                      loading={callingAPI}
                      onClick={() => handleSend()}
                    >
                      {t('rewards.google_play_rating.btn')}
                    </Button>
                  </div>
                </div>
              }
            </div>
          </div>
        </Collapse.Panel>
      </Collapse>
    </div>
  );
}

export default GooglePlayRating;